__turbopack_context__.v({
  "Profile": "Profile-module__PRo3aa__Profile",
});
